import Link from 'next/link'; 
import {downloadLink } from '@/lib/utils.js'
import parse from 'html-react-parser'; 
import {renderAtKey, positionHTML,  _cartButton  } from '@/components/customizable_area_utilities'

export default function CustomizableProductDescriptionArea({primarySpecSheet, cartActive, itemInCart, cart, product, resource_display, config }) {

 const productOpts = {primarySpecSheet: primarySpecSheet, cartActive: cartActive, 
   itemInCart: itemInCart, cart: cart, product:  product, resource_display: resource_display, config: config}

    const defaultHTML = ( ) => {
      return ( 
        <>
         {product.long_description && (
          <div
            data-testid="product-description"
            dangerouslySetInnerHTML={{ __html: product.long_description }}
            className="lexcms-product-description"
          ></div>
        )}
        {!product.long_description && (
          <p
            data-testid="product-description"
            className="lexcms-product-description"
          >
            {product.description}
          </p>
        )}      
        </ >
      )
    }

  return (
    <>
      {positionHTML('beforebegin', 'description_area', productOpts)}
      <div className='lexcms-product-description-area'>
        {positionHTML('afterbegin', 'description_area',  productOpts)}
        {!positionHTML('replace', 'description_area',  productOpts)  &&
            defaultHTML()
        }
        {positionHTML('replace', 'description_area',  productOpts)}
        {positionHTML('beforeend', 'description_area',  productOpts)}
      </div>
      {positionHTML('afterend', 'description_area', productOpts)}
    </>
  )
}

